const Navbar = () => {
    return (
      <nav>
        <div className="nav">
          <img
            src="../my-travel-journal/Images/logo.png"
            alt="logo"
            className="logo"
          />
          <p>my travel journal.</p>
        </div>
      </nav>
    );
}
export default Navbar;